import React from 'react';
import func from 'prop-types';
import SlideoutHeader from 'ps-components/Slideout/Header/SlideoutHeader';
import SlideoutHeaderButton from 'ps-components/Slideout/Header/SlideoutHeaderButton';

import './YearOverYearHeader.scss';

class YearOverYearHeader extends React.Component {
  static propTypes = {
    closeSlideout: func
  };

  render() {
    const { closeSlideout } = this.props;

    const printYearOverYearDialogBox = () => {
      window.print();
    };

    return (
      <SlideoutHeader
        title="Year Over Year"
        additionalButtons={<SlideoutHeaderButton iconClass="icon-print" onClick={printYearOverYearDialogBox} />}
        doClose={closeSlideout}
      />
    );
  }
}

export default YearOverYearHeader;
